import { useController, useFormContext } from "react-hook-form";
import { AsyncSelectField } from "../fields/AsyncSelectField";
import { AsyncProps } from "react-select/async";

type Option = {
  label: string;
  value: string | number;
};

type OwnProps = {
  label?: string;
  helperText?: string;
  name: string;
  onChange?: (value: any) => void;
  retrieveAsyncOptions: (inputValue: string) => Promise<Option[]>;
} & AsyncProps<any, any, any>;

export const AsyncSelectInput = ({
  name,
  onChange,
  loadOptions,
  options,
  retrieveAsyncOptions,
  ...rest
}: OwnProps) => {
  const { control, formState, getFieldState } = useFormContext();

  const {
    field: { ref, value, onChange: controllerOnChange, ...controllerRest },
  } = useController({
    name: name as string,
    control,
  });

  return (
    <AsyncSelectField
      innerRef={ref}
      errorMessage={getFieldState(name as string, formState).error?.message}
      onChange={(value) => {
        // react-select hands back an array of options when isMulti is set, so
        // the form field holds an array of ids in that case and a single id
        // otherwise.
        const newValue = rest.isMulti
          ? ((value as Option[] | null) ?? []).map((option) => option.value)
          : (value as Option | null)?.value;
        controllerOnChange(newValue);
        if (onChange) {
          onChange(newValue);
        }
      }}
      retrieveAsyncOptions={retrieveAsyncOptions}
      value={value}
      {...rest}
      {...controllerRest}
    />
  );
};
